import _taggedTemplateLiteral from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";
import _extends from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
import _classCallCheck from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/createClass.js";
import _possibleConstructorReturn from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _inherits from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/inherits.js";
import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;
var __jsx = React.createElement;
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import styled, { keyframes } from 'styled-components';
import { fonts, colorPalette, textStyles } from '../../../../styles/styleGuide';
import { toBreakpoint } from '../../../../styles/breakpoints';
import Label from './Label';
import ErrorMessage from './ErrorMessage';
import DatePicker from './DatePicker';
import ClickOutHandler from 'react-onclickout';
import getRegExFromString from '../../../../services/getRegExFromString';
var Input = /*#__PURE__*/function (_Component) {
  function Input() {
    var _this;
    _classCallCheck(this, Input);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, Input, [].concat(args));
    _defineProperty(_this, "inputRef", null);
    _defineProperty(_this, "state", {
      showDatePicker: false,
      value: _this.props.defaultValue || ''
    });
    _defineProperty(_this, "initializeValue", function (_ref) {
      var defaultValue = _ref.defaultValue;
      if (_this.state.value !== defaultValue) {
        _this.setState({
          value: defaultValue || ''
        });
      }
    });
    _defineProperty(_this, "showDatePicker", function () {
      if (_this.props.type === 'bamDate') {
        _this.setState({
          showDatePicker: true
        });
      }
    });
    _defineProperty(_this, "hideDatePicker", function () {
      if (_this.props.type === 'bamDate') {
        _this.setState({
          showDatePicker: false
        });
      }
    });
    _defineProperty(_this, "handleChange", function (evt) {
      _this.props.onChange(evt);
    });
    _defineProperty(_this, "handleDateChange", function (date) {
      if (!date) return;
      var formattedDate = date.toLocaleTimeString('nl-NL', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit'
      }).replace(/[^\x00-\x7F]/g, '') // This incredibly dumb step is required for IE11.
      .substring(0, 10);
      _this.setState({
        showDatePicker: false,
        value: formattedDate
      }, function () {
        if (_this.inputRef) {
          var ev = new CustomEvent('datePicker', {
            bubbles: true,
            cancelable: true,
            detail: {
              type: 'datePicker',
              value: formattedDate
            }
          });
          _this.inputRef.dispatchEvent(ev);
          // $FlowFixMe
          _this.props.onChange(ev);
        }
      });
    });
    _defineProperty(_this, "onClickOut", function (evt) {
      var type = _this.props.type;
      if (type === 'bamDate' && _this.state.showDatePicker) {
        _this.hideDatePicker();
      }
    });
    return _this;
  }
  _inherits(Input, _Component);
  return _createClass(Input, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.initializeValue(this.props);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props,
        id = _this$props.id,
        type = _this$props.type,
        name = _this$props.name,
        required = _this$props.required,
        color = _this$props.color,
        className = _this$props.className,
        maxLength = _this$props.maxLength,
        defaultValue = _this$props.defaultValue,
        pattern = _this$props.pattern,
        isValid = _this$props.isValid,
        validationMessage = _this$props.validationMessage,
        toggle = _this$props.toggle,
        togglePassword = _this$props.togglePassword,
        title = _this$props.title,
        _this$props$placehold = _this$props.placeholder,
        placeholder = _this$props$placehold === void 0 ? '' : _this$props$placehold;
      var locale = type === 'number' ? {
        lang: 'nl-NL'
      } : {};
      return __jsx(InputContainer, {
        withError: !!validationMessage,
        "data-id": "fieldTypes_Input_InputContainer"
      }, __jsx(ClickOutHandler, {
        onClickOut: this.onClickOut,
        "data-id": "fieldTypes_Input_ClickOutHandler"
      }, __jsx(InputEl, _extends({
        id: id,
        type: type === 'number' ? 'text' : type,
        name: name,
        required: required,
        defaultValue: defaultValue,
        color: color,
        className: className,
        placeholder: placeholder,
        maxLength: maxLength,
        onKeyUp: this.handleChange,
        onChange: this.handleChange,
        onInput: this.handleChange,
        onFocus: this.showDatePicker,
        pattern: type === 'bamDate' ? '(0[0-9]|1[0-9]|2[0-9]|3[0-1])-(0[0-9]|1[0-2])-([0-9]{4})' : type === 'number' ? '^([0-9]+|[0-9]{1,3}(,[0-9]{3})*)(,[0-9]+)?$' : pattern ? getRegExFromString(String(pattern)) : null,
        ref: function ref(el) {
          _this2.inputRef = el;
        },
        autoComplete: type === 'password' ? 'off' : 'on'
      }, locale, {
        "data-id": "fieldTypes_Input_InputEl"
      })), __jsx(Label, {
        name: name,
        content: title,
        required: required,
        color: color,
        "data-id": "fieldTypes_Input_Label"
      }), type === 'bamDate' && this.state.showDatePicker && __jsx(DatePicker, {
        selectedDate: String(this.state.value),
        onChange: this.handleDateChange,
        closePicker: this.hideDatePicker,
        "data-id": "fieldTypes_Input_DatePicker"
      }), validationMessage && __jsx(ErrorMessage, {
        isValid: isValid,
        message: validationMessage,
        color: color,
        "data-id": "fieldTypes_Input_ErrorMessage"
      }), toggle && __jsx(Toggle, {
        onClick: togglePassword,
        "data-id": "fieldTypes_Input_Toggle"
      }, type === 'password' ? 'Toon' : 'Verberg')));
    }
  }]);
}(Component);
export default Input;
var InputContainer = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  position: relative;\n  min-width: 250rem;\n  background-color: transparent;\n\n  ", "\n"])), function (props) {
  return props.withError ? 'margin-bottom: 20rem;' : '';
});
var autofill = keyframes(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  100% {\n      background: transparent;\n      color: inherit;\n  }\n}\n"])));
var InputEl = styled.input(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  box-sizing: border-box;\n  width: 100%;\n  height: 46rem;\n  padding-bottom: 1rem;\n  padding-left: 0;\n  padding-top: 0;\n  border: 0;\n  border-bottom: solid 1rem;\n  border-bottom-color: ", ";\n  border-radius: 0;\n  font-family: ", ";\n  font-size: 100%;\n  color: ", ";\n  background: none;\n  transition: all 0.15s ease-in-out;\n  -webkit-transform: translateZ(0px);\n\n  &:-webkit-autofill,\n  &:-webkit-autofill:hover,\n  &:-webkit-autofill:focus {\n    -webkit-text-fill-color: ", ";\n    animation: ", " 0s forwards;\n  }\n\n  &:focus {\n    border-bottom: solid 2rem;\n    border-bottom-color: ", ";\n    padding-bottom: 0rem;\n    outline: 0;\n\n    + label {\n      ", ";\n    }\n  }\n\n  &.filled {\n    outline: 0;\n\n    + label {\n      ", ";\n    }\n  }\n\n  &:-webkit-autofill {\n    outline: 0;\n\n    + label {\n      ", ";\n    }\n  }\n\n  + label {\n    ", ";\n    bottom: 10rem;\n    pointer-events: none;\n  }\n"])), function (props) {
  return props.color ? props.color : colorPalette.beige;
}, fonts.primary, function (props) {
  return props.color ? props.color : colorPalette.textGrey;
}, function (props) {
  return props.color ? props.color : colorPalette.textGrey;
}, autofill, function (props) {
  return props.color ? props.color : colorPalette.beige;
}, textStyles.formLabelAnimation, textStyles.formLabelAnimation, textStyles.formLabelAnimation, textStyles.formLabelDefault);
var Toggle = styled.div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  ", ";\n  color: ", ";\n  position: absolute;\n  right: 5rem;\n  top: 20rem;\n  cursor: pointer;\n\n  ", ";\n"])), textStyles.caption, colorPalette.blue, toBreakpoint.md(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n    font-size: 12rem;\n  "]))));